(function() {
  'use strict';

  window.addEventListener('DOMContentLoaded', () => {
    hoverDropDown();
  });

  function hoverDropDown() {
    // Bootstrap 'lg' breakpoint (992px)
    const desktopBreakpoint = 992;

    // Find all dropdown list items within the navbar
    const dropdowns = document.querySelectorAll('.navbar-nav .dropdown');

    dropdowns.forEach(function(dropdownElement) {
      // Create a new Bootstrap Dropdown instance for programmatic control
      const toggler = dropdownElement.querySelector('.dropdown-toggle');
      if (!toggler) {
        return;
      }
      const bsDropdown = bootstrap.Dropdown.getOrCreateInstance(toggler);

      // Function to handle showing the dropdown on mouseenter
      const showDropdown = () => {
        // Only execute if screen width is at or above the desktop breakpoint
        if (window.innerWidth >= desktopBreakpoint) {
          bsDropdown.show();
        }
      };

      // Function to handle hiding the dropdown on mouseleave
      const hideDropdown = () => {
        if (window.innerWidth >= desktopBreakpoint) {
          // Use a short delay before hiding to allow cursor movement within the menu
          setTimeout(() => {
            // Check if the cursor is still outside the dropdown container
            if (!dropdownElement.matches(':hover')) {
              bsDropdown.hide();
            }
          }, 100);
        }
      };

      // Attach event listeners
      dropdownElement.addEventListener('mouseenter', showDropdown);
      dropdownElement.addEventListener('mouseleave', hideDropdown);

      // Ensure dropdown closes if window is resized down to mobile size
      window.addEventListener('resize', function() {
        if (window.innerWidth < desktopBreakpoint) {
          bsDropdown.hide();
        }
      });

    });
  }

})();
